import AdminLayout from './AdminLayout.component'

export default AdminLayout
